<template>
  <div class="terms" :class="termsWrapperClass">
    <a-lazy-hydrate when-visible>
      <a-breadcrumbs :breadcrumbs-dynamic-names="breadcrumbsDynamicNames" />
    </a-lazy-hydrate>

    <a-letter-navigation class="terms__letter-navigation" />

    <nuxt-child />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import ABreadcrumbs from 'shared/ABreadcrumbs'
import ALetterNavigation from '@/components/_sections/terms/ALetterNavigation'
import { ROUTE_NAME } from '@/utils/enums/routes'

const CURRENT_BREADCRUMB_ITEM_NAME = 'Industry Terms'

export default {
  name: 'TermsHomePage',
  head() {
    return this.$generateMetaTags({
      titleParam: 'Terms',
      descriptionParam: 'Terms'
    })
  },
  mixins: [mixins.setPageLoaded],
  components: { ALetterNavigation, ABreadcrumbs },
  computed: {
    breadcrumbsDynamicNames() {
      return {
        [ROUTE_NAME.TERMS]: CURRENT_BREADCRUMB_ITEM_NAME
      }
    },
    isTermPageRoute() {
      return ROUTE_NAME.TERMS_LETTER_SLUG === this.$route.name
    },
    termsWrapperClass() {
      return {
        'term-letter': this.isTermPageRoute
      }
    }
  }
}
</script>

<style scoped lang="scss">
.terms {
  &.term-letter {
    margin-top: 60px;

    @include desktop-sm {
      margin-top: 0;
    }
  }

  &__letter-navigation {
    margin-bottom: 30px;

    @include mobile {
      margin-bottom: 10px;
    }
  }
}
</style>
